//modules
import React from 'react';
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CSSRulePlugin } from 'gsap/CSSRulePlugin';
import { NavigationBar } from '../globalComponents/NavigationBar';
import { ProjectsFooter } from '../globalComponents/ProjectsFooter';
import { useImageAnimation } from '../globalComponents/UseImageAnimation';
import { useTextAnimation } from '../globalComponents/UseTextAnimation';
import { UpButton } from '../globalComponents/UpButton';

// styles
import './Projects.scss';
import vintach_1 from '../images/vintach_1.webp';
import vintach_2 from '../images/vintach_2.webp';
import vintach_3 from '../images/vintach_3.webp';
import vintach_4 from '../images/vintach_4.webp';
import vintach_5 from '../images/vintach_5.webp';
import vintach_6 from '../images/vintach_6.gif';
import vintach_7 from '../images/vintach_7.webp';
import vintach_8 from '../images/vintach_8.webp';
import vintach_9 from '../images/vintach_9.webp';
import vintach_10 from '../images/vintach_10.webp';
import vintach_11 from '../images/vintach_11.webp';
import vintach_12 from '../images/vintach_12.webp';
import vintach_13 from '../images/vintach_13.webp';
import vintach_14 from '../images/vintach_14.webp';
import vintach_15 from '../images/vintach_15.webp';
import vintach_16 from '../images/vintach_16.webp';
import vintach_17 from '../images/vintach_17.webp';
import project_ticketsocket from '../images/project_ticketsocket.webp';
import project_aptia from '../images/project_aptia.webp';
import project_disney from '../images/project_disney.webp';
import doldrumdrifters from '../images/doldrumdrifters.webp';

// plugins
gsap.registerPlugin(CSSRulePlugin, ScrollTrigger);

export const Vintach = () => {


  const StuffData = [ 
    ['Unity Design System', 'White label design system for a benefits administration company.', project_aptia, '/Projects/DesignSystem'],
    ['Ticketing Ecosystem', 'Product Ideation & UI Design for a ticketing ecosystem.', project_ticketsocket, '/Projects/Ticketing'],
    ['Figma To Code', 'Low code and design system tools to streamline better hand-off processes at Disney.', project_disney, '/Projects/FigmaToCode'],
    ['Other Stuff', 'Personal projects covering illustration, code experiments and more.', doldrumdrifters, '/OtherStuff'],
 ];

    const { containerRefs, imageRefs } = useImageAnimation(17);
    const { textRef, headingRef, subtitleRef, bodyRef } = useTextAnimation();
 
  return (
    <div>
    <div>
      <NavigationBar />

      <div className="subpage-heading" ref={headingRef}>
        <h2 className="heading-2">
            Vintage Marketplace.
        </h2>
        <div className="subpage-subtitle">
          <p className="subtitle" ref={(el) => (subtitleRef.current[0] = el)}>Responsabilities</p>
          <p className="subtitle-bold" ref={(el) => (subtitleRef.current[1] = el)}>Branding, Product Ideation & UI</p>
        </div>
      </div>

      <div className="project-content">

        {/* Content */}
        <div className="project-body">
            <h5 className="heading-5" ref={(el) => (bodyRef.current[0] = el)}>/ Context</h5>
            <p className="project-notes body" ref={(el) => (bodyRef.current[1] = el)}>Vintach was developed as the final project for my degree in Visual Communication Design. It stems from my passion for fashion and sustainability, but more importantly, from my dissatisfaction with Uruguay’s fashion market, which is heavily reliant on fast fashion. This digital product aims to foster the growth of the second-hand fashion industry at a national level.</p>
        </div>

        {/* Image 1 */}
        <section className="main">
            <div ref={containerRefs.current[0]} className="container">
              <div className="img-container">
                  <img className="single-img" ref={imageRefs.current[0]} src={vintach_1} alt="Project Visual 0" />
              </div>
            </div>
        </section>

        {/* Content */}
        <div className="project-body">
            <h5 className="heading-5" ref={(el) => (textRef.current[0] = el)}>/ The Problem</h5>
            <p className="project-notes body" ref={(el) => (textRef.current[1] = el)}>The second-hand fashion market is growing in Uruguay, with many young people and adults relying on it for income, while fashion enthusiasts embrace it for its affordability and unique offerings. However, existing platforms such as flea markets and social media, are not fully meeting the industry's evolving needs. Sellers struggle to reach new buyers, while buyers find it challenging to discover items that match their preferences. This project aims to address these pain points by creating a brand and product that improves the experience and potentially drive industry growth.</p>
        </div>

        {/* Section Title */}
        <div className="project-body">
            <h3 className="heading-3 section-heading" ref={(el) => (textRef.current[2] = el)}> Brand Design. </h3>
        </div>

        {/* Image 2 */}
        <section className="main">
            <div ref={containerRefs.current[1]} className="container">
              <div className="img-container">
                  <img className="single-img" ref={imageRefs.current[1]} src={vintach_2} alt="Project Visual 1" />
              </div>
            </div>
        </section>

        {/* Image 3 */}
        <section className="main">
            <div ref={containerRefs.current[2]} className="container">
              <div className="img-container">
                  <img className="single-img" ref={imageRefs.current[2]} src={vintach_3} alt="Project Visual 2" />
              </div>
            </div>
        </section>

        {/* Content */}
        <div className="project-body">
            <h5 className="heading-5" ref={(el) => (textRef.current[3] = el)}>/ Brand Design</h5>
            <p className="project-notes body" ref={(el) => (textRef.current[4] = el)}>Since the project focused on giving clothes a second life, the brand design celebrates the charm of vintage fashion, inspired by iconic styles from the 1950s to the 2000s. The brand’s visuals incorporate a distinct risographic texture to create a consistent retro aesthetic, while geometric illustrations and a bright, energetic color palette infuse the brand with a modern twist, appealing to a younger audience.</p>
        </div>

        {/* Image 4 & 5 */}
        <section className="main row-container large-gap">
            <div ref={containerRefs.current[3]} className="multiple-container">
              <div className="img-container">
                  <img className="single-img" ref={imageRefs.current[3]} src={vintach_4} alt="Project Visual 3" />
              </div>
            </div>
            <div ref={containerRefs.current[4]} className="multiple-container">
              <div className="img-container">
                  <img className="single-img" ref={imageRefs.current[4]} src={vintach_5} alt="Project Visual 4" />
              </div>
            </div>
        </section>

        {/* Image 6 & 7 */}
        <section className="main row-container large-gap">

        { /*Image */}
            <div ref={containerRefs.current[5]} className="multiple-container">
              <div className="img-container">
                  <img className="single-img" ref={imageRefs.current[5]} src={vintach_6} alt="Project Visual 5" />
              </div>
            </div>
            <div ref={containerRefs.current[6]} className="multiple-container">
              <div className="img-container">
                  <img className="single-img" ref={imageRefs.current[6]} src={vintach_7} alt="Project Visual 6" />
              </div>
            </div>
        </section>

        {/* Section Title */}
        <div className="project-body">
            <h3 className="heading-3 section-heading" ref={(el) => (textRef.current[5] = el)}> Product Definition. </h3>
        </div>

        {/* Content */}
        <div className="project-body">
            <h5 className="heading-5" ref={(el) => (textRef.current[6] = el)}>/ Discovery</h5>
            <p className="project-notes body" ref={(el) => (textRef.current[7] = el)}>To create a product that truly met user needs, I conducted in-depth research to gather valuable insights. This included analyzing existing platforms used by the target audience to sell second-hand clothing, as well as conducting personal interviews across a diverse demographic range. I explored both online marketplaces and in-person events to collect and analyze data that would shape the final product. While this case study highlights key findings, the research is extensive, so feel free to request the full project if you’d like to explore it further.</p>
        </div>

         {/* Image 8 */}
         <section className="main">
            <div ref={containerRefs.current[7]} className="container">
              <div className="img-container">
                  <img className="single-img" ref={imageRefs.current[7]} src={vintach_8} alt="Project Visual 8" />
              </div>
            </div>
        </section>

        {/* Section Title */}
        <section className="main">

        { /*Image 9 */}
            <div ref={containerRefs.current[8]} className="container">
              <div className="img-container">
                  <img className="single-img" ref={imageRefs.current[8]} src={vintach_9} alt="Project Visual 8" />
              </div>
            </div>
        </section>

        {/* Section Title */}
        <div className="project-body">
            <h3 className="heading-3 section-heading" ref={(el) => (textRef.current[8] = el)}> UI Design. </h3>
        </div>

        {/* Content */}
        <div className="project-body">
            <h5 className="heading-5" ref={(el) => (textRef.current[9] = el)}>/ Mobile App</h5>
                <p className="project-notes body" ref={(el) => (textRef.current[10] = el)}>Drawing from thorough research and user insights, I designed a mobile application that retains familiar experiences for those accustomed to buying and selling clothing on social media. The app introduces essential yet previously unavailable features tailored to this industry, such as advanced filtering, security measures for buyers and sellers, and customizable shipping options. While offering these specialized capabilities, it also preserves the community-driven interaction that defined previous platforms. 
                    <a href="https://vimeo.com/816215166" target="_blank" rel="noopener noreferrer">
                    → Here’s a link to the prototype demo
                    </a>.</p>
        </div>

         {/* Images 10 & 11 */}
         <section className="main row-container medium-gap">
            { /*Image */}
            <div className="mobile-row medium-gap">
                <div ref={containerRefs.current[9]} className="multiple-container">
                    <div className="img-container">
                        <img className="single-img" ref={imageRefs.current[9]} src={vintach_10} alt="Project Visual 9" />
                    </div>
                </div>
                { /* In Between Content */}    
                <div className="ui-notes hide-text">
                    <p className="body" ref={(el) => (textRef.current[11] = el)}> Interface is playful and colorful to preserve branding and appeal to the primary target user group. </p>
                </div>
                {/* Image */}
                <div ref={containerRefs.current[10]} className="multiple-container">
                    <div className="img-container">
                        <img className="single-img" ref={imageRefs.current[10]} src={vintach_11} alt="Project Visual 10" />
                    </div>
                </div>
            </div>
                { /* In Between Content */}    
                <div className="ui-notes">
                    <p className="body" ref={(el) => (textRef.current[12] = el)}> The home page interface remained similar to social media applications used by the primary user type. Most of its features are beneficial to the second hand industry. </p>
                    <p className="body" ref={(el) => (textRef.current[13] = el)}> A publication consists in an image, a description of the item and details such as size and material. The “like” button can be used to save items of interest. </p>
                </div>
            </section>

        {/* Images 12, 13 & 14 */}
        <section className="main row-container medium-gap">
            { /*Image */}
            <div ref={containerRefs.current[11]} className="multiple-container">
                <div className="img-container">
                    <img className="single-img" ref={imageRefs.current[11]} src={vintach_12} alt="Project Visual 12" />
                </div>
            </div>
            { /* In Between Content */}    
            <div className="ui-notes">
                <p className="body" ref={(el) => (textRef.current[14] = el)}> One of the main needs of the application was the possibility to filter through different types of criteria, allowing users to find specific items. </p>
                <p className="body" ref={(el) => (textRef.current[15] = el)}> Filters include a variety of options such as price, size, period of fabrication, type of item, brand and more. </p>
            </div>
            <div className="mobile-row">
                {/* Image */}
                <div ref={containerRefs.current[12]} className="multiple-container">
                    <div className="img-container">
                        <img className="single-img" ref={imageRefs.current[12]} src={vintach_13} alt="Project Visual 13" />
                    </div>
                </div>
                {/* Image */}
                <div ref={containerRefs.current[13]} className="multiple-container">
                    <div className="img-container">
                        <img className="single-img" ref={imageRefs.current[13]} src={vintach_14} alt="Project Visual 14" />
                    </div>
                </div>
            </div>
        </section>

        {/* Images 15 & 16 */}
        <section className="main row-container medium-gap">
        { /* In Between Content */}    
            <div className="ui-notes">
                <p className="body text-right" ref={(el) => (textRef.current[16] = el)}> On the profile page, there can be found three different categories of publications: Items published, Items bought and items saved. </p>
                <p className="body text-right" ref={(el) => (textRef.current[17] = el)}> Seller profiles are similar to Instagram’s profiles, maintaining a similar layout since it’s a convenient way to visualize items on sale and sold items. </p>
            </div>
        { /*Image */}
        <div ref={containerRefs.current[14]} className="multiple-container">
            <div className="img-container">
                <img className="single-img" ref={imageRefs.current[14]} src={vintach_15} alt="Project Visual 15" />
            </div>
        </div>
        { /* In Between Content */}    
        <div className="ui-notes">
            <p className="body" ref={(el) => (textRef.current[18] = el)}> Each publication has detailed information about the garment, answers to questions that multiple users have asked about the item. </p>
        </div>
        {/* Image */}
        <div ref={containerRefs.current[15]} className="multiple-container">
            <div className="img-container">
                <img className="single-img" ref={imageRefs.current[15]} src={vintach_16} alt="Project Visual 16" />
            </div>
        </div>
        </section>

        {/* Content */}
        <div className="project-body">
            <h5 className="heading-5" ref={(el) => (textRef.current[19] = el)}>/ Desktop Platform</h5>
            <p className="project-notes body" ref={(el) => (textRef.current[20] = el)}>To ensure a seamless experience across devices, I also designed a desktop platform that mirrors the mobile application’s functionality. It offers the same intuitive features while optimizing usability for larger screens, providing users with flexibility and consistency no matter how they choose to engage with the marketplace.</p>
        </div>

        {/* Image 17 */}
        <section className="main">
            <div ref={containerRefs.current[16]} className="container">
              <div className="img-container">
                  <img className="single-img" ref={imageRefs.current[16]} src={vintach_17} alt="Project Visual 8" />
              </div>
            </div>
        </section>

        {/* Content */}
        <div className="top-spacer last-body">
            <h5 className="heading-5" ref={(el) => (textRef.current[21] = el)}>/ Takeaways</h5>
            <div className="project-notes body" ref={(el) => (textRef.current[22] = el)}>This project was a unique opportunity to bring a personal passion to life, allowing me to design an entire product rooted in my long-standing interest in vintage clothing. As a personal endeavor, I was able to infuse creativity into the branding, ensuring it authentically represented the vibrant community I’m part of. It was an exciting journey of combining personal connection with design, which made the project all the more meaningful.</div>
        </div>

      </div>

      <ProjectsFooter StuffData={StuffData} />
      </div>
      <UpButton />
      

    </div>
  );
};
